(function () {
  var roots = document.querySelectorAll('[data-bioss-products-tabs]');

  roots.forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bioss-products-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bioss-products-panel]'));

    if (!tabs.length || !panels.length) return;

    function activateTab(nextTab, moveFocus) {
      var panelId = nextTab.getAttribute('aria-controls');

      tabs.forEach(function (tab) {
        var isActive = tab === nextTab;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.id !== panelId;
      });

      if (moveFocus) {
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nextTab.focus();
        nextTab.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex !== index) {
          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        }
      });
    });

    var hashPanelId = window.location.hash ? window.location.hash.slice(1) : '';
    var hashPanel = hashPanelId ? document.getElementById(hashPanelId) : null;
    var initialTab = tabs[0];

    if (hashPanel && root.contains(hashPanel) && hashPanel.hasAttribute('data-bioss-products-panel')) {
      var matchingTab = root.querySelector('[aria-controls="' + hashPanel.id + '"]');
      if (matchingTab) initialTab = matchingTab;
    }

    var hub = root.closest('.bioss-products-hub');
    if (hub) hub.classList.add('is-tabs-ready');
    activateTab(initialTab, false);
  });
})();
